export default __webpack_public_path__ + "static/media/mother-dairy.6243797a.png";